import React, { useCallback, useContext } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { Link } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { FormattedMessage } from 'react-intl';
import { EntryPageTemplate } from 'gw-components-platform-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import metadata from './AppError.metadata.json5';
import styles from './AppError.module.scss';
import messages from './AppError.messages';

const { applicationDetails, env } = appConfig;

function AppErrorPage() {
    const translator = useContext(TranslatorContext);
    const onLogoutLink = useCallback(() => {
        const signInLink = `${_.get(env, 'DEPLOYMENT_URL')}/logout.do`;
        return (
            <div>
                <FormattedMessage
                    {...messages.AppErrorLink}
                    values={{
                        signIn: (
                            <Link href={signInLink} className={styles.signInLink}>
                                {
                                    translator(messages.signIn)
                                }
                            </Link>
                        )
                    }}
                />
            </div>
        );
    // Execute only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const overrides = {
        logoutLink: {
            content: onLogoutLink()
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent, overrides, resolvers
    );

    return (
        <EntryPageTemplate
            applicationName={applicationDetails.applicationName}
            applicationLogo={applicationDetails.applicationLogo}
            contentToRender={renderedContentFromMetadata}
            isWideContent
        />
    );
}

export default AppErrorPage;
